import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import { useUpdatePaymentMethodForm } from "@Light/components/page/form/UpdatePaymentMethod";
import {
  useHeaderBackNavigate,
  useHeaderTitle,
} from "@Light/components/page/header/context";
import { MutationButton } from "@Light/components/page/MutationButton";
import { StripeElements } from "@Light/components/page/payment/StripeElements";
import { useScaffold } from "@Light/scaffold";
import React from "react";

export type UpdatePaymentMethodProps = {
  hideBack?: boolean;
  backLink?: string;
};

export const UpdatePaymentMethod: React.FC<UpdatePaymentMethodProps> = ({
  hideBack,
  backLink,
}) => {
  useHeaderTitle("Update payment method");
  useHeaderBackNavigate(
    hideBack ? undefined : backLink || "/account/payment-method/",
  );

  return (
    <StripeElements>
      <UpdatePaymentMethodWithElements />
    </StripeElements>
  );
};

export type UpdatePaymentMethodWithElementsProps = {};
export const UpdatePaymentMethodWithElements: React.FC<
  UpdatePaymentMethodWithElementsProps
> = ({}) => {
  const scaffold = useScaffold();
  const { onSubmit, mutation, form, stripeError } =
    useUpdatePaymentMethodForm(true);

  if (mutation.isSuccess) {
    const Navigate = scaffold.system.navigate;
    return <Navigate to="/account/payment-method/payment-method-updated" />;
  }

  const PageBody = scaffold.page.pageBody;
  return (
    <form>
      <PageBody
        footerAfterContent={true}
        footer={
          <ButtonFooter>
            <MutationButton
              size="lg"
              mutation={mutation}
              mutateButtonText="Update payment method"
              mutate={onSubmit}
              errorMessage={
                stripeError ??
                "Error updating payment method. Please try again later."
              }
            />
          </ButtonFooter>
        }
      >
        <div className="pt-8">{form}</div>
      </PageBody>
    </form>
  );
};
